module.exports = __webpack_public_path__ + "static/media/power_supply_image.167b5209.svg";